import { RefObject, useEffect, useRef } from 'react';

export function useEventListener<TElement extends HTMLElement, TEvent extends keyof HTMLElementEventMap>(
    elementRef: RefObject<TElement | null>,
    type: TEvent,
    listener: (event: HTMLElementEventMap[TEvent]) => void,
    options?: AddEventListenerOptions,
) {
    const listenerRef = useRef(listener);

    useEffect(() => {
        listenerRef.current = listener;
    });

    useEffect(() => {
        const element = elementRef.current;

        if (element == null) {
            return;
        }

        const listenerWrapper = (event: HTMLElementEventMap[TEvent]) => {
            listenerRef.current(event);
        };

        element?.addEventListener(type, listenerWrapper, options);

        return () => element?.removeEventListener(type, listenerWrapper, options);
    }, [elementRef, type, options]);
}
